module.exports = ".example-container{overflow:auto}mat-table{width:100%}.caducado{color:red}.onTime{color:green}\n"